import React, { useEffect } from "react";
import useInput from "../../../hooks/useIndicatorInput";
import IsRequiredModule from "./IsRequiredModule";

const MacdSetting = (props) => {
  const { indicator, updateIndicator, isLong,t } = props;

  const [fast, bindFast, setFast] = useInput(indicator.period_num, 0);
  const [slow, bindSlow, setSlow] = useInput(indicator.value2, 0);
  const [signal, bindSignal, setSignal] = useInput(indicator.value3, 0);

  useEffect(() => {
    setFast(indicator.period_num);
    setSlow(indicator.value2);
    setSignal(indicator.value3);
  }, [indicator]);

  useEffect(() => {
    updateIndicator({
      ...indicator,
      period_num: fast,
      value2: slow,
      value3: signal,
    });
  }, [fast, slow, signal]);
  return (
    <div>
      <h6>{isLong ? "Long" : "Short"} Strategy</h6>
      <div>
        <label>Fast Period:</label>
        <input type="number" {...bindFast} />
      </div>
      <div>
        <label>Slow Period:</label>
        <input type="number" {...bindSlow} />
      </div>
      <div>
        <label>Signal Period:</label>
        <input type="number" {...bindSignal} />
      </div>
      <IsRequiredModule indicator={indicator} updateIndicator={updateIndicator} t={t}></IsRequiredModule>
    </div>
  );
};

export default MacdSetting;
